export default "__VITE_ASSET__DZvU0Pf2__"